import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

const TermsAndConditionsApi = {
    isRelevantSigned: strictQuery({
        In: z.union([z.literal('user'), z.literal('advisor')]),
        Out: z.object({ isRelevantSigned: z.boolean() }),
        handler: (role) => axios.get('/tac/is-relevant-signed', { params: { role } }),
    }),

    loadRelevant: strictQuery({
        In: z.union([z.literal('user'), z.literal('advisor')]),
        Out: z.string(),
        handler: (role) => axios.get('/tac/load-relevant', { params: { role } }),
    }),

    signRelevant: strictQuery({
        In: z.union([z.literal('user'), z.literal('advisor')]),
        Out: z.any(),
        handler: (role) => axios.post('/tac/sign-relevant', null, { params: { role } }),
    }),
};

export default TermsAndConditionsApi;
